import { render, staticRenderFns } from "./tablePre.vue?vue&type=template&id=19bfda55"
import script from "./tablePre.vue?vue&type=script&lang=js"
export * from "./tablePre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports